// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1AQGh","sidebar-menu":"Sidebar_sidebar-menu__SGdS8","menu-icon":"Sidebar_menu-icon__125wu"};